'use client';

import type { ReactNode } from 'react';
import { AnimatedSticker } from '~/components/animated-sticker';
import { SheetDescription, SheetHeader, SheetTitle } from '~/components/ui';
import { TGS_STICKERS } from '~/constants/tgs-stickers';

interface ConfirmationContentProps {
  title: string;
  description: string;
  content: ReactNode;
}

export const ConfirmationContent = ({ title, description, content }: ConfirmationContentProps) => (
  <>
    <SheetHeader>
      <div className="flex flex-col space-y-4">
        <div className="size-30 mb-6 self-center">
          <AnimatedSticker autoplay loop src={TGS_STICKERS.HAPPY} />
        </div>

        <SheetTitle>
          <div className="text-center text-white font-bold text-[24px]">{title}</div>
        </SheetTitle>
        <SheetDescription className="text-center">
          <span className="text-center text-white/60 font-bold text-[16px]">{description}</span>
        </SheetDescription>
      </div>
    </SheetHeader>
    <div className="pt-6 overflow-hidden">{content}</div>
  </>
);
